import React from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { ROUTES } from '../routes/routes'
import ConverterPage from '../pages/ConverterPage'
import ContactUsPage from '../pages/ContactUsPage'
import AboutUsPage from '../pages/AboutUsPage'
import NotFoundPage from '../pages/NotFoundPage'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { PageViewTracker } from '../contexts/GA4Provider'
import MeasureRedirectorPage from '../pages/MeasureRedirectorPage'
import Homepage from '../pages/Homepage'


const AppRouter: React.FC = () => (
  <Router>
    <Header />
    <PageViewTracker />
    <Routes>
      {/* Redirect root to a converter */}
      <Route path="/" element={<Navigate to={ROUTES.HOME} replace />} />

      {/* routes */}
      <Route path={ROUTES.HOME} element={<Homepage />} />
      <Route path={ROUTES.MEASURE.pattern} element={<MeasureRedirectorPage />} />
      <Route path={ROUTES.CONVERTER.pattern} element={<ConverterPage />} />
      <Route path={ROUTES.CONTACT_US} element={<ContactUsPage />} />
      <Route path={ROUTES.ABOUT_US} element={<AboutUsPage />} />
      <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND} replace />} />
    </Routes>
    <Footer />
  </Router>
)

export default AppRouter
